import React from "react";
import { tono } from "./tonos";

/**
 * Tarjeta KPI con semáforo del kit de tableros: barra del tono arriba,
 * valor grande, nota y chips opcionales (conteos por color). Clic en la
 * tarjeta o en un chip = filtro que abre el tracking (nunca lista filas).
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-09-14
 * @param {string} titulo   Kicker de la tarjeta
 * @param {number|string} valor Número grande
 * @param {string} nota     Texto pequeño bajo el valor
 * @param {string} tonoxxx  ROJO | NARANJA | AMARILLO | VERDE | AZUL | MORADO | NAVY | GRIS
 * @param {boolean} activa  Resaltada (filtro vigente)
 * @param {function} onClick Drill-down de la tarjeta
 * @param {Array} chips     [{clave, texto, tonoxxx, apagada, onClick, titulo}]
 */
const Kpitarjx = ({ titulo, valor, nota, tonoxxx = "NAVY", activa = false, onClick, chips = [] }) => {
  const t = tono(tonoxxx);
  return (
    <div
      className={`tbl-card tbl-kpi ${onClick ? "clic" : ""} ${activa ? "activa" : ""}`}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      title={onClick ? "Ver en su pantalla" : undefined}
    >
      <div className="tbl-kpi-barra" style={{ background: t.hex }} />
      <span className="tbl-kicker">{titulo}</span>
      <span className="tbl-kpi-valor" style={{ color: tonoxxx === "NAVY" || tonoxxx === "GRIS" ? undefined : t.hex }}>{valor}</span>
      {nota && <span className="tbl-kpi-nota">{nota}</span>}
      {chips.length > 0 && (
        <div style={{ display: "flex", gap: 4, flexWrap: "wrap", marginTop: 2 }}>
          {chips.map((chip) => {
            const tc = tono(chip.tonoxxx);
            return (
              <button
                key={chip.clave}
                type="button"
                className={`tbl-chip ${chip.onClick ? "clic" : ""} ${chip.apagada ? "apagada" : ""}`}
                style={{ background: tc.hex, color: "#FFFFFF" }}
                title={chip.titulo}
                onClick={(e) => {
                  e.stopPropagation();
                  chip.onClick?.();
                }}
              >
                {chip.texto}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Kpitarjx;
